import { Record } from 'immutable';
import { PartyType } from './party-type';
import { Contact } from './contact';

const PartyRecord = Record({
  eventPartyId: 0,
  version: 0,
  createDate: null,
  modifiedDate: null,
  brand: null,
  chain: null,
  propertyId: null,
  agencyId: null,
  clientReferenceNumber: null,
  partyType: null,
  name: null,
  eventId: null,
  line1: null,
  line2: null,
  city: null,
  state: null,
  postalCode: null,
  eventReferenceNumber: null,
  contact: new Contact()
});

export class Party extends PartyRecord {
  eventPartyId: number;
  version: number;
  createdDate: Date;
  modifiedDate: Date;
  brand: string;
  chain: string;
  propertyId: string;
  agencyId: string;
  clientReferenceNumber: string;
  partyType: PartyType;
  name: string;
  eventId: number;
  line1: string;
  line2: string;
  city: string;
  state: string;
  postalCode: string;
  eventReferenceNumber: string;
  contact: Contact;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/party.ts